import { Link as ChakraLink } from '@chakra-ui/react';

type LinkProps = React.ComponentProps<typeof ChakraLink>;

const Link = ({ children, ...props }: Readonly<LinkProps>) => {
  return <ChakraLink {...props}>{children}</ChakraLink>;
};

export default Link;
